/**
 * @author sai shiva
 * @Date: 2022-03-03 16:15:15
 * @Last Modified by: sai shiva
 * @Last Modified time: 2022-03-03 18:25:30
 */

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { bool } from 'prop-types';
import { Row, Col, Icon } from 'antd';
import StyledMoneyfy from './StyledMoneyfy';
import endPoints from '../../../config/endPoints';
import LandingContainer from '../../../components/LandingContainer';
import { HeaderContainer } from '../../HeaderContainer/Loadable';
import { constants } from '../../../devUtils';
import Loader from '../../../components/Loader';

class Moneyfy extends Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: true };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.hideLoader();
  }

  componentWillUnmount() {
  }

  hideLoader() {
    const proc = new Promise((resolve) => {
      setTimeout(() => resolve(), 20);
    });
    proc.then(() => this.setState({ isLoading: false }));
  }

  render() {
    const { isHideHeader } = this.props;
    const { isLoading } = this.state;
    if (isLoading) {
      return <Loader />;
    }
    return (
      <StyledMoneyfy>
        {!isHideHeader ? <HeaderContainer location={this.props} /> : ''}
        <nav className="nav-bg-white padding-1">
          <Row align="middle" type="flex" justify="start">
            <Col xs={24} sm={24} md={1} lg={1} xl={1} />
            <Col xs={24} sm={24} md={7} lg={7} xl={7}>
              <Link to={constants.LINK_HOME}>
                <img
                  src={endPoints.ZAGGLE_LOGO.URL}
                  alt={endPoints.ZAGGLE_LOGO.ALT}
                  className="width-4"
                />
              </Link>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8} className="text-center">
              <h1 className="text-red nomargin-bottom">Invest in Mutual Funds</h1>
            </Col>
            <Col xs={24} sm={24} md={8} lg={8} xl={8} />
          </Row>
        </nav>
        <section className="margin-t-1">
          <LandingContainer>
            <Row align="middle" type="flex" justify="start" className="moneyfy-header">
              <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                <img
                  src={endPoints.MONEYFY_LOGO.URL}
                  alt={endPoints.MONEYFY_LOGO.ALT}
                  className="width-8 moneyfy-logo"
                />
              </Col>
              <Col xs={24} sm={24} md={14} lg={14} xl={14}>
                <p className="text-white nomargin-bottom font-24">Grow your wealth through suitable Investments</p>
              </Col>
              <Col xs={24} sm={24} md={4} lg={4} xl={4} />
            </Row>
            <Row align="middle" type="flex">
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center margin-t-1">
                <h1 className="nomargin-bottom">Invest In Popular Categories</h1>
                <hr className="bdr-hr" />
              </Col>
            </Row>
          </LandingContainer>
        </section>
        <section className="padding-t-2">
          <LandingContainer>
            <Row align="middle" type="flex" gutter={36}>
              <Col xs={24} sm={24} md={6} lg={6} xl={6} className="text-center">
                <img
                  src={endPoints.MONEYFY_TOP_RATED_FUNDS.URL}
                  alt={endPoints.MONEYFY_TOP_RATED_FUNDS.ALT}
                  className="moneyfy-features-imgs"
                />
                <h1 className="nomargin-bottom">Top Rated <br />Funds</h1>
                <strong>Rated By Morning Star, Value Research.</strong>
              </Col>
              <Col xs={24} sm={24} md={6} lg={6} xl={6} className="text-center">
                <img
                  src={endPoints.MONEYFY_TAX_SAVER_FUNDS.URL}
                  alt={endPoints.MONEYFY_TAX_SAVER_FUNDS.ALT}
                  className="moneyfy-features-imgs"
                />
                <h1 className="nomargin-bottom">Tax Saver <br />Funds</h1>
                <strong>Funds That Are Rated Highly By Morningstar And Value Research</strong>
              </Col>
              <Col xs={24} sm={24} md={6} lg={6} xl={6} className="text-center">
                <img
                  src={endPoints.MONEYFY_INVEST_IN_GOLD.URL}
                  alt={endPoints.MONEYFY_INVEST_IN_GOLD.ALT}
                  className="moneyfy-features-imgs"
                />
                <h1 className="nomargin-bottom">Invest in <br />Gold</h1>
                <strong>Rated By Morningstar, Value Research</strong>
              </Col>
              <Col xs={24} sm={24} md={6} lg={6} xl={6} className="text-center">
                <img
                  src={endPoints.MONEYFY_STARTING_SIP.URL}
                  alt={endPoints.MONEYFY_STARTING_SIP.ALT}
                  className="moneyfy-features-imgs"
                />
                <h1 className="nomargin-bottom">Starting <br />SIP at 500</h1>
                <strong>Rated By Morningstar, Value Research.</strong>
              </Col>
              <Col xs={24} sm={24} md={4} lg={4} xl={4} />
              <Col xs={24} sm={24} md={16} lg={16} xl={16} className="text-center margin-t-2">
                <h1 className="font-20 hightlighter">Get Amazon voucher worth <span className="text-highlight">INR 500</span> on your first investment</h1>
              </Col>
              <Col xs={24} sm={24} md={4} lg={4} xl={4} />
              <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center padding-t-1">
                <Link to={constants.LINK_CAMPAIGN_MONEYFY} className="btn btn-green" target="_blank" >START INVESTING <Icon type="right" /></Link>
                <p className="font-12 margin-t-2">Tata Securities Limited (TSL) is registered with The Association of Mutual Funds in India as a Mutual Fund Distributor bearing ARN No. 0021. All Mutual Fund Investments are subject to market risks, read all scheme related documents carefully before investing for full understanding and details. Products/ offers/services offered on Zaggle Application are independently brought to you by Zaggle Prepaid Ocean Services Pvt. Ltd- a third party entity and are completely at its sole discretion and may be withdrawn or modified by such entity at any time without prior notice. TSL/Moneyfy shall assume no responsibility or liability in any manner whatsoever for any such products/ offers/services. Terms and conditions apply.</p>
              </Col>
            </Row>
          </LandingContainer>
        </section>
      </StyledMoneyfy>
    );
  }
}

Moneyfy.propTypes = {
  isHideHeader: bool,
};
Moneyfy.defaultProps = {
  isHideHeader: false,
};
export default Moneyfy;



// WEBPACK FOOTER //
// client/containers/Campaigns/Moneyfy/index.js